import Vue from 'vue';
import VueI18n from 'vue-i18n';
import kr from './kr'
import en from './en'
import de from './de'
import sa from './ar'
import jp from './jp'
import th from './th'
import vn from './vn'

Vue.use(VueI18n);

// 定义语言包
export const messages = {
  en: en,
  kr: kr,
  de: de,
  sa: sa,
  jp: jp,
  th: th,
  vn: vn
};
// 创建 i18n 实例
const i18n = new VueI18n({
  locale: 'en', // 默认语言
  fallbackLocale: 'en', // 回退语言
  messages
});

export default i18n;